import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f8082a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "step-payment" }
const _hoisted_2 = { class: "bill-address" }
const _hoisted_3 = { class: "box-submit" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Save and Continue ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Save This Address? ")

import { ColorVariants } from '@/constants';
  import InfoBill from './info-bill-address.vue';
  import InfoPayment from './info-payment.vue';
  import { CheckoutStore } from '@/stores';

  interface IProps {
    store: CheckoutStore
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    store: null
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  const _component_AppLoadingButton = _resolveComponent("AppLoadingButton")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(InfoPayment),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(InfoBill)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_AppLoadingButton, {
        class: "btn-submit",
        pill: "",
        variant: _unref(ColorVariants).primary
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["variant"]),
      _createVNode(_component_b_form_checkbox, { class: "checkbox" }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ]))
}
}

})